import { fetchWithCache, getCachedData } from "../services/apiService";

export const userBalance = async (user_id, { setBalance }) => {
  const cacheKey = `/api/user/userKeyBalance_${user_id}`;

  // Show cached data immediately if available
  const cached = getCachedData(cacheKey, {});
  if (cached) {
    setBalance(cached.key_balance);
  }

  try {
    const data = await fetchWithCache(
      "/api/user/userKeyBalance",
      {
        method: "POST",
        body: JSON.stringify({ user_id }),
        cacheKey,
        retries: 2,
        timeout: 10000,
      },
      true,
    );
    setBalance(data.key_balance);
  } catch (err) {
    if (!cached) {
      setBalance(null);
    }
  }
};
